export enum APIRouteMap {
  //public
  CONTENT_GETLANGUAGES = 'content/getlanguages',
  CONTENT_GETTRANSLATES = 'content/gettranslates',
  CONTENT_GETTRANSLATES_SUFFIX = '/EMPLOYER_STRINGS',
  AUTH = 'auth',
  USER_SETUSERPASSWORD = 'user/setuserpassword',
  USER_RECOVERYPASSWORDINIT = 'user/recoverypasswordinit',
  USER_RECOVERYPASSWORDCOMPLETE = 'user/recoverypasswordcomplete',
  ABONAMENTS_GETREPORT = 'abonaments/getreport',
  SUBSCRIPTIONS_GETFILTERS = 'admindashboard/getsearchfilters',
  SUBSCRIPTIONS_GETLIST = 'admindashboard/getreport',
  SUBSCRIPTIONS_CLOSE = 'employee/close',
  SUBSCRIPTIONS_ACTIVATE = 'subscription/activate',
  SUBSCRIPTIONS_GETEMPLOYEEDATABYCNP = 'employee/getemployeedata',
  SUBSCRIPTION_UPLOADFILE = 'subscription/uploadfile',
  EMPLOYEE_UPLOADFILE = 'employee/uploadfile',
  SUBSCRIPTION_GETDEFAULTUPLOADTEMPLATE = 'subscription/getdefaultuploadtemplate',
  SUBSCRIPTIONS_UPDATE = 'employee/modifydata',
  INVOICES_GETSUBSCRIPTIONTYPES = 'invoice/getsearchfilters',
  INVOICES_GETLIST = 'invoice/getreport',
  INVOICES_DOWNLOADPDF = 'invoice/invoicepdf',
  INVOICES_DOWNLOADEXCEL = 'invoice/exportinvoiceproducts',
}
